import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';
import { BillingFeature, ModelName } from 'webapp/enums/enums';

import type TemplateRecord from 'webapp/models/template';

export default class ReportsPublicTemplatesTemplateRoute extends Route {
	@service('model-manager/templates') declare mmTemplatesService: Service.ModelManager.Templates;
	@service('navigation') declare navigationService: Service.Navigation;
	@service('popup') declare popupService: Service.Popup;
	@service('store') declare storeService: Service.Store;
	@service('billing') declare billingService: Service.Billing;

	override beforeModel(): Promise<unknown> {
		// make sure request for templates has finished before we go search for model
		return this.mmTemplatesService.requestReportPublicTemplates();
	}

	override model(params: { template_id: string }): TemplateRecord | void {
		let model;

		if (params) {
			model = this.storeService.peekRecord(
				ModelName.TEMPLATE,
				params.template_id,
			) as TemplateRecord;
		}

		if (!model) {
			this.navigationService.replaceRoute('reports.public-templates');
			return;
		}

		return model;
	}

	override afterModel(model: TemplateRecord): void {
		const templateModel = this.mmTemplatesService.createModel(model);

		const onTemplateUse = () => {
			if (this.billingService.checkIfCan(BillingFeature.REPORTS_BASIC, true)) {
				this.navigationService.transitionToRoute(
					'reports.public-templates.template.connect',
					model,
				);
			}
		};
		const onPopupClose = () => {
			// Prevent transitioning to reports.public-templates when transitioning
			// to settings.billing.plan (because of reports data story feature limitation - transitionToPlansAndShowReportsGrowthBubble)
			if (this.navigationService.activatedRoute.startsWith('settings.billing.plan')) {
				return;
			}

			this.navigationService.transitionToRoute('reports.public-templates');
		};

		this.mmTemplatesService.openPreviewPopup(
			templateModel,
			onTemplateUse,
			undefined,
			onPopupClose,
		);
	}
}
